import _regeneratorRuntime from "@babel/runtime/regenerator";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
import { Link } from '@inertiajs/inertia-vue3';
import Icon from '@/Shared/Icon';
import Logo from '@/Shared/Logo';
import Dropdown from '@/Shared/Dropdown';
import MainMenu from '@/Shared/MainMenu';
import FlashMessages from '@/Shared/FlashMessages';
import Loader from '@/Shared/Loader';
export default {
  components: {
    Dropdown: Dropdown,
    FlashMessages: FlashMessages,
    Icon: Icon,
    Link: Link,
    Logo: Logo,
    MainMenu: MainMenu,
    Loader: Loader
  },
  props: {
    auth: Object
  },
  mounted: function mounted() {
    this.refreshAccessArray();
  },
  methods: {
    refreshAccessArray: function refreshAccessArray() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res, data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return axios.post('/users/access');
              case 3:
                res = _context.sent;
                _context.next = 9;
                break;
              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);
                res = _context.t0.response;
              case 9:
                _context.prev = 9;
                data = res.data;
                if (data.status == 'success') {
                  _this.$store.can = data.can;
                } else {
                  console.log(data);
                }
                return _context.finish(9);
              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0, 6, 9, 13]]);
      }))();
    }
  }
};